declare global {
  interface Window {
    dataLayer: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export const track = (event: string, params?: Record<string, unknown>): void => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
};

export type ConsentPreferences = {
  analytics: boolean;
  marketing: boolean;
};

// Atualiza o Consent Mode v2 (Google Tag Manager)
// Aceita boolean (libera/nega tudo) ou objeto granular { analytics, marketing }
export const updateConsent = (
  granted: boolean | ConsentPreferences,
): void => {
  if (typeof window === 'undefined') return;

  const prefs: ConsentPreferences = typeof granted === 'boolean'
    ? { analytics: granted, marketing: granted }
    : granted;

  const analyticsState = prefs.analytics ? 'granted' : 'denied';
  const marketingState = prefs.marketing ? 'granted' : 'denied';

  const consentUpdate = {
    ad_storage: marketingState,
    ad_user_data: marketingState,
    ad_personalization: marketingState,
    analytics_storage: analyticsState,
  };

  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', consentUpdate);
  } else {
    // Fallback: empurra direto se gtag não existir (ex: GTM bloqueado)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(['consent', 'update', consentUpdate]);
  }
};
